export default "__VITE_ASSET__fb960c22__"